import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-player-overview',
  templateUrl: './player-overview.component.html',
  styleUrls: ['./player-overview.component.css']
})

export class PlayerOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
